import InputDatetime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

export default function Filters({ filters, setFilters }) {
    const { encounterAgents } = useReportFiltersFetch({ fetchEncounterAgents: true });

    return (
        <div className={`mb-2 ${minMenuHeight}`}>
            <form className="space-y-4">
                <InputDatetime
                    id="dtStart"
                    label="Data/hora inicial *"
                    dateFormat="LL"
                    classNameWrapper="w-full"
                    selected={filters.dtStart}
                    onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                />
                <InputDatetime
                    id="dtEnd"
                    label="Data/hora final *"
                    dateFormat="LL"
                    classNameWrapper="w-full"
                    selected={filters.dtEnd}
                    onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                />
                <SelectComponent
                    id="user"
                    label="Abordado por"
                    classNameWrapper={"w-full"}
                    isMulti={true}
                    options={encounterAgents}
                    value={filters.user}
                    onChange={(value) => setFilters(prev => ({ ...prev, user: value }))}
                />
            </form>
        </div>
    )
}